export const DIALOG_VERSION = '1.0.3';
export const DIALOG_VERSION_KEY = 'adminuiDialogVersion';